export enum ContactMode {
  CONTACT_SHARE = "CONTACT_SHARE",
  LEAD_CAPTURE = "LEAD_CAPTURE",
  SESSION_ATTENDANCE = "SESSION_ATTENDANCE",
  ACCESS_CONTROL = "ACCESS_CONTROL"
}
export type PremiumContactMode = ContactMode.LEAD_CAPTURE | ContactMode.SESSION_ATTENDANCE | ContactMode.ACCESS_CONTROL;
export const PremiumContactModes: Array<PremiumContactMode> = [
  ContactMode.LEAD_CAPTURE,
  ContactMode.SESSION_ATTENDANCE,
  ContactMode.ACCESS_CONTROL
];

export namespace ContactMode {
  export function isPremiumContactMode(mode: ContactMode): mode is PremiumContactMode {
    return PremiumContactModes.includes(mode as PremiumContactMode);
  }
}

export default ContactMode;
